import React from 'react';

import { DialogActions, DialogTitle } from '@mui/material';
import { Box } from '@mui/system';
import { type ModalizerProps } from './Modalizer';

export const ModalContent: React.FunctionComponent<
    Pick<ModalizerProps, 'children' | 'modalActions' | 'modalTitle'>
> = function ({ children, modalActions, modalTitle }) {
    return (
        <>
            {modalTitle && (
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {modalTitle}
                </DialogTitle>
            )}

            <Box
                style={{
                    marginTop: '30px',
                    marginBottom: '30px',
                }}
            >
                {children}
            </Box>

            {modalActions && <DialogActions>{modalActions}</DialogActions>}
        </>
    );
};
